import React from "react";
import GetTopBannerData from "../utils/GetTopBannerData";

const useFetchBannerData = () => {
  const [bannerData, setBannerData] = React.useState(null);

  React.useEffect(() => {
    try {
      GetTopBannerData().then((data) => {
        setBannerData(data);
      });
    } catch (e) {
      console.log(e);
    }
  }, []);

  return { bannerData };
};

export default useFetchBannerData;
